import { createFileRoute, Outlet } from '@tanstack/react-router'

/**
 * Brands section layout (Area E). Renders only the nested outlet: the E1 list at
 * the index route, the brand-detail (E3/E4/E5) tree under `$brandId`.
 */
export const Route = createFileRoute('/_ws/w/$workspaceId/brands')({
  component: () => <Outlet />,
})
